// services/abstract/SixCatalogService.ts
import type { SixesCatalogApiResponse } from "@/types/six/SixDTOs";

export abstract class SixCatalogService {
  /**
   * Returns ALL visible SIXes for the current user.
   */
  abstract fetchSixes(search?: string): Promise<SixesCatalogApiResponse>;
}
